/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any */
declare let sys: any;
import { hall } from '../hall'

export class FunctionUtils {
  public static SM_EVENT(eventKey) {
    let strSysKey = 'androw'
    if (sys.os == sys.OS.IOS) {
      strSysKey = 'ios'
    }

    if (globalThis.aplus_queue) {
      //
      const tParam = {
        param1: strSysKey,
        param2: hall.userModule.userId,
      }
      //
      globalThis.aplus_queue.push({
        action: 'aplus.record',
        arguments: [eventKey, 'CLK', tParam],
      })
    }
  }

  public static SM_EVENT_TIME(eventKey, dbTime) {
    let strSysKey = 'androw'
    if (sys.os == sys.OS.IOS) {
      strSysKey = 'ios'
    }

    if (globalThis.aplus_queue) {
      //
      const tParam = {
        param1: strSysKey,
        param2: hall.userModule.userId,
        dbTime: dbTime,
      }
      //
      globalThis.aplus_queue.push({
        action: 'aplus.record',
        arguments: [eventKey, 'DURATION', tParam],
      })
    }
  }

  public static ssqShow() {
    if (globalThis.ssqShow) {
      globalThis.ssqShow()
    }
  }

  /** 获取时间戳，默认 秒 */
  public static stamp(ms = false) {
    if (ms) return new Date().getTime()
    return Math.floor(new Date().getTime() / 1000)
  }
}
